export default "__VITE_ASSET__iCjJyb$X__"